import axios from "axios";
import {BaseResponse} from "../../../BaseResponse";
import {TankReleaseCertificate} from "../getTankReleaseList";

export async function postTankReleaseCertificate(tankReleaseId: string, tankReleaseCertificate: TankReleaseCertificate) {
    const response = await axios.post<BaseResponse<boolean>>(`/tank/release/${tankReleaseId}/certificate`, tankReleaseCertificate)

    return response.data
}